import React, { Component } from "react";

export default class ProjectsImg extends Component {
  render() {
    // const theme = this.props.theme;
    return (
      <svg
        id="ea02ba7f-3a41-458b-a9ee-53c1e5920f6c"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        width="579.23228"
        height="563.50586"
        viewBox="0 0 579.23228 563.50586"
      >
        <path
          d="M534.02624,681.49581l-15.08405,13.88667,11.98765-20.11431c-9.4445-17.12689-24.89088-31.92871-24.89088-31.92871s-32.04585,30.70246-32.04585,54.83659,14.34734,32.56087,32.04585,32.56087c17.69823,0,32.04557-8.42673,32.04557-32.56087C538.08453,692.80429,536.49463,687.1074,534.02624,681.49581Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#f2f2f2"
        />
        <path
          d="M515.063,696.13426v1.18959c-.07066,13.82775-2.40275,24.61668-6.97863,32.21367-.06477.1119-.13544.2179-.20025.32979l-.51235-.3121-.48877-.30625c5.07644-8.20359,6.87263-19.79933,6.9374-31.86031.00589-.3887.01179-.78326.00589-1.17783-.01768-5.10592-.32979-10.27068-.83035-15.28825-.03533-.38871-.07656-.78327-.11779-1.17783-.69492-6.61941-1.69608-12.94435-2.72079-18.43894-.07066-.38871-.14723-.77737-.22379-1.16018-1.77264-9.29307-3.58061-16.02437-3.99286-17.51434-.04709-.18256-.07656-.28267-.08246-.30621l.55948-.159.00589-.00589.56538-.159c.00589.02358.106.35926.27087.98351.63015,2.33208,2.26735,8.66292,3.87508,17.01374.07066.37691.14723.76562.21789,1.15429.83625,4.45809,1.65485,9.44033,2.30268,14.66986q.24732,1.97.44169,3.88686c.04709.39457.08831.78913.12365,1.17783Q515.0336,689.02313,515.063,696.13426Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#fff"
        />
        <path
          d="M511.13494,659.99839c-.39457.053-.795.106-1.20138.14723a32.49,32.49,0,0,1-3.32149.17081,31.60342,31.60342,0,0,1-13.66284-3.08591c-.24734.3121-.49467.62424-.7479.94225a32.77364,32.77364,0,0,0,14.41074,3.32149,33.61622,33.61622,0,0,0,3.54528-.18846c.40046-.04123.80092-.09425,1.19548-.15312a32.49749,32.49749,0,0,0,9.39321-2.84448q-.37985-.48584-.742-.954A31.49481,31.49481,0,0,1,511.13494,659.99839Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#fff"
        />
        <path
          d="M514.0972,679.7094q-.60953.03533-1.21906.03534c-.12369.00589-.25323.00589-.37692.00589A31.771,31.771,0,0,1,486.424,666.129c-.23555.34744-.47113.69491-.70078,1.04825a32.95074,32.95074,0,0,0,26.778,13.75119c.16492,0,.3298,0,.49471-.00589.41221-.0059.81856-.01769,1.22492-.03534a32.77636,32.77636,0,0,0,17.46135-6.12473c-.18846-.34744-.37691-.69492-.57127-1.04236A31.55274,31.55274,0,0,1,514.0972,679.7094Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#fff"
        />
        <path
          d="M515.063,696.13426c-.41221.03533-.82446.05888-1.23671.07656-.44168.01765-.88337.02944-1.32506.02944a31.85693,31.85693,0,0,1-30.54114-22.92061c-.265.47706-.53.94818-.78326,1.4252a33.02351,33.02351,0,0,0,31.3244,22.67324c.44169,0,.88338-.00589,1.31917-.02944.41814-.01179.83039-.03533,1.2426-.0648a32.92693,32.92693,0,0,0,21.731-10.60638c-.12368-.43579-.265-.86568-.40635-1.30148A31.75415,31.75415,0,0,1,515.063,696.13426Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#fff"
        />
        <path
          d="M888.77789,198.42415H311.22211a.83826.83826,0,0,1,0-1.67651H888.77789a.83826.83826,0,0,1,0,1.67651Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#cacaca"
        />
        <circle cx="19.70553" cy="9.22077" r="9.22077" fill="#3f3d56" />
        <circle cx="51.55911" cy="9.22077" r="9.22077" fill="#3f3d56" />
        <circle cx="83.4127" cy="9.22077" r="9.22077" fill="#3f3d56" />
        <path
          d="M869.6928,173.88712H847.06a1.67651,1.67651,0,0,1,0-3.353H869.6928a1.67651,1.67651,0,1,1,0,3.353Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#3f3d56"
        />
        <path
          d="M869.6928,180.174H847.06a1.67651,1.67651,0,0,1,0-3.353H869.6928a1.67651,1.67651,0,1,1,0,3.353Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#3f3d56"
        />
        <path
          d="M869.6928,186.4609H847.06a1.67651,1.67651,0,0,1,0-3.353H869.6928a1.67651,1.67651,0,1,1,0,3.353Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#3f3d56"
        />
        <rect
          x="17.39935"
          y="68.08588"
          width="529.27979"
          height="280.41998"
          fill="#f0f0f0"
        />
        <path
          d="M857.063,288.82294v-2.75H754.03321v-49.74h-2.75v49.74H648.25293v-49.74h-2.75v49.74H542.47315v-49.74h-2.75v49.74H436.69287v-49.74h-2.75v49.74H327.78321v2.75H433.94287v54.95H327.78321v2.75H433.94287v54.95H327.78321v2.75H433.94287v54.94H327.78321v2.75H433.94287v54.84h2.75v-54.84H539.72315v54.84h2.75v-54.84H645.50293v54.84h2.75v-54.84H751.28321v54.84h2.75v-54.84H857.063v-2.75H754.03321v-54.94H857.063v-2.75H754.03321V346.523H857.063v-2.75H754.03321v-54.95Zm-317.33984,170.34H436.69287v-54.94H539.72315Zm0-57.69H436.69287V346.523H539.72315Zm0-57.69995H436.69287v-54.95H539.72315Zm105.77978,115.39H542.47315v-54.94H645.50293Zm0-57.69H542.47315V346.523H645.50293Zm0-57.69995H542.47315v-54.95H645.50293Zm105.78028,115.39H648.25293v-54.94H751.28321Zm0-57.69H648.25293V346.523H751.28321Zm0-57.69995H648.25293v-54.95H751.28321Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#fff"
        />
        <rect
          x="146.80512"
          y="133.93944"
          width="35.40913"
          height="34.28022"
          fill="#cacaca"
        />
        <rect
          x="472.80512"
          y="244.93944"
          width="35.40913"
          height="34.28022"
          fill="#cacaca"
        />
        <rect
          x="157.80512"
          y="301.93944"
          width="35.40913"
          height="34.28022"
          fill="#cacaca"
        />
        <rect
          x="168.27001"
          y="127.57947"
          width="35.40913"
          height="34.28022"
          fill="#6c63ff"
        />
        <polygon
          points="370.13 270.076 412.149 232.639 424.545 238.781 374.149 291.639 370.13 270.076"
          fill="#ffb6b6"
        />
        <circle cx="417.67913" cy="235.50586" r="10" fill="#ffb6b6" />
        <polygon
          points="330.799 551.856 320.856 551.856 316.126 513.506 330.8 513.507 330.799 551.856"
          fill="#ffb6b6"
        />
        <path
          d="M643.71818,729.74076l-32.05873-.00118v-.40549a12.47883,12.47883,0,0,1,12.47815-12.478h.00079l19.58038.00079Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#2f2e41"
        />
        <polygon
          points="294.799 551.856 284.856 551.856 280.126 513.506 294.8 513.507 294.799 551.856"
          fill="#ffb6b6"
        />
        <path
          d="M607.71818,729.74076l-32.05873-.00118v-.40549a12.47883,12.47883,0,0,1,12.47815-12.478h.00079l19.58038.00079Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#2f2e41"
        />
        <path
          d="M649.53311,500.88614s25-2,17,42-24.57086,164.36139-24.57086,164.36139l-15.02362,2.065L618.063,548.75293l-6.71491,160.55961-19.10717-2.065-18.7078-172.36139s-6.00695-13.85827-.00347-23.42914S649.53311,500.88614,649.53311,500.88614Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#2f2e41"
        />
        <path
          d="M633.53311,391.88614l6.941-3.71862s17.101-1.45855,24.08,18.63L683.063,434.75293l30-26,13,9-37.80893,45.12462-15.721,2.00859-34-44Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#3f3d56"
        />
        <path
          d="M608.34649,310.753c-28.51758,0-36.5,31.32684-36.5,49,0,17.6731,16.34155,15,36.5,15,8.65246,0,16.59655.48847,22.85223-.34692l3.00867-7.34693,2.42132,6.08765c5.13483-1.88666,8.21778-5.7215,8.21778-13.3938C644.84649,342.07981,637.84649,310.753,608.34649,310.753Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#2f2e41"
        />
        <circle cx="297.84055" cy="181.91534" r="24.56103" fill="#ffb6b6" />
        <path
          d="M579.84646,347.75293v0h9.71435l4.28565-12,.85693,12h4.64307l2.5-7,.5,7h34.5v0a26,26,0,0,0-26-26h-5A26,26,0,0,0,579.84646,347.75293Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#2f2e41"
        />
        <rect
          x="398.27001"
          y="197.57947"
          width="35.40913"
          height="34.28022"
          fill="#6c63ff"
        />
        <path
          d="M657.3042,491.83759c-3.771.04852-15.12988-67.35-15.12988-67.35l-1.7002-36.32-12.41113-.41717V386.934a6.18126,6.18126,0,0,0-6.18115-6.18109h-23.6377a6.17631,6.17631,0,0,0-6.16113,5.7879l-9.73291-.32714-16.856,53.55389s15.53223,49.76031,8.03565,71.68939c0,0,73.03808,6.272,87.02051-7.64941C660.5503,503.80756,661.0752,491.789,657.3042,491.83759Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#3f3d56"
        />
        <path
          d="M586.53311,392.88614,582.35,386.21369s-13.61027-3.36487-19.21357,5.65379S541.063,449.75293,541.063,449.75293l17,6,19.29135-27.04556Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#3f3d56"
        />
        <rect
          x="283.27001"
          y="259.57947"
          width="35.40913"
          height="34.28022"
          fill="#6c63ff"
        />
        <path
          d="M566.48659,440.21644,554.16774,438.913l0,0a12.085,12.085,0,0,0,8.57723,16.98054l48.74344,9.72822-5.08446-15.65894Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#ffb6b6"
        />
        <circle cx="301.25138" cy="287.55513" r="10" fill="#ffb6b6" />
        <path
          d="M599.15162,466.10645l-37.13453-8.48535a16.0433,16.0433,0,0,1-11.63232-10.64063l-1.50073-4.62793,9.63745-7.584,44.15283,12.34082Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#3f3d56"
        />
        <path
          d="M807.82283,731.75293h-381a1,1,0,1,1,0-2h381a1,1,0,0,1,0,2Z"
          transform="translate(-310.38386 -168.24707)"
          fill="#cacaca"
        />
      </svg>
    );
  }
}
